<template>
	<div>
		<div id="no-events-found" v-if="filteredList.length == 0">{{loadedMessage}}</div>

		<div class="events-list">
			<div v-for="(event, index) in filteredList" :key="index">
				<eventItem :event="event.node" />
			</div>
		</div>
	</div>
</template>

<script>
// import { store } from "./_juicebox-store.js";
import moment from "moment";
import { range } from "lodash";
import eventItem from "./events-list-item.vue";
import { mapGetters, mapActions } from "vuex";

export default {
	name: "events-list",
	data() {
		return {
			data: this.$store.state,
			loaded: this.$store.state.loaded
		};
	},
	components: { eventItem },
	mounted() {
		this.data.filteredEvents = this.filteredList ? this.filteredList : [];
	},
	computed: {
		...mapGetters(["allEvents"]),
		timeSpan: function() {
			return this.data.timeSpan;
		},
		loadedMessage: function() {
			return this.data.loaded
				? "No events found."
				: "Loading data. Please wait...";
		},
		filteredList: function() {
			let filteredData =
				this.data.filteredEvents.length != 0
					? this.data.filteredEvents
					: this.data.events;
			return filteredData;
		}
	},
	methods: {}
};
</script>

<style lang="scss" scoped>
#no-events-found {
	text-align: center;
}
</style>